import { CompetitionGallery } from "@/Components/Competition/CompetitionGallery";
import { CompetitionVideo } from "@/Components/Competition/CompetitionVideo";
import { HeroCompetition } from "@/Components/Competition/Hero";
import { RendersOfWorkArts } from "@/Components/Competition/RendersOfWorkArts";
import { WorkArts } from "@/Components/Competition/WorkArts";
import Modal from "@/Components/Modal";
import FrontLayout from "@/Layouts/FrontLayout";
import { InertiaPage } from "@/types/inertia";
import { Head, router, useForm, usePage } from "@inertiajs/react";
import {
    ChangeEvent,
    FormEventHandler,
    SVGProps,
    useEffect,
    useState,
} from "react";
import WorkArt1 from "@resources/competition/workart-1.png?format=webp&quality=80&width=1200;767;600;375&as=srcset&imagetools";
import WorkArt2 from "@resources/competition/workart-2.png?format=webp&quality=80&width=1200;767;600;375&as=srcset&imagetools";
import WorkArt3 from "@resources/competition/workart-3.png?format=webp&quality=80&width=1200;767;600;375&as=srcset&imagetools";
import ContactForm from "@/Components/Universal/ContactForm";

const LineMdClose = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                fill="none"
                stroke="currentColor"
                strokeDasharray={12}
                strokeDashoffset={12}
                strokeLinecap="round"
                strokeWidth={2}
                d="M12 12L19 19M12 12L5 5M12 12L5 19M12 12L19 5"
            >
                <animate
                    fill="freeze"
                    attributeName="stroke-dashoffset"
                    dur="1s"
                    values="12;0"
                ></animate>
            </path>
        </svg>
    );
};

export default function Competition() {
    const [selectedProject, setSelectedProject] = useState<number | null>(null);
    const [show, setShow] = useState<boolean>(false);
    const { error } = usePage<InertiaPage>().props.flash;

    const { data, setData, post, errors, wasSuccessful } = useForm({
        email: "",
        project: selectedProject,
    });

    const submitProject: FormEventHandler = (e) => {
        e.preventDefault();

        // try {
        //     post(route('frontend.competition.post'), {
        //         preserveScroll: false,
        //         onSuccess: () => {
        //             setTimeout(() => {
        //                 router.visit(route('frontend.competition.thankYou') + '#dziekujemy-za-glosowanie');
        //             }, 3000)
        //         },
        //     });
        // } catch (e) {
        //     console.log(e)
        // }
    };

    useEffect(() => {
        if (selectedProject) {
            setShow(true);
        } else {
            setShow(false);
        }

        setData("project", selectedProject);
    }, [selectedProject]);

    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name="description" content="Osiedle Kusocińskiego" />
            </Head>
            <FrontLayout>
                <HeroCompetition />
                {/* <WorkArts setSelectedProject={setSelectedProject} /> */}
                {/* <section className="mt-12 mb-24 lg:px-20 px-4">
                    <a
                        className="bg-primary button-primary max-w-[400px] text-center w-full mx-auto"
                        href="/polityka-informacyjna-w-zakresie-ochrony-danych-osobowych-glosowanie-na-mural-udv.pdf"
                        target="_blank"
                    >
                        Polityka prywatności konkursu
                    </a>
                </section> */}
                <RendersOfWorkArts />
                <CompetitionVideo />
                <CompetitionGallery />
                <Modal
                    show={show}
                    onClose={() => {
                        setShow(false);
                        setSelectedProject(null);
                    }}
                    maxWidth="3xl"
                >
                    <div className="py-10 px-6 flex flex-col items-center justify-center relative">
                        <button
                            onClick={() => {
                                setShow(false);
                                setSelectedProject(null);
                            }}
                            type="button"
                            className="absolute right-1 top-1"
                        >
                            <LineMdClose />
                        </button>
                        <div className="grid w-full items-start gap-x-6 md:grid-cols-2">
                            <form
                                onSubmit={submitProject}
                                className="md:mb-0 mb-8"
                            >
                                <h2 className="text-h4 text-primary tracking-wide font-semibold">
                                    Zagłosuj na projekt nr {selectedProject}
                                </h2>
                                <p className="text-p text-text mt-4 mb-8">
                                    Aby wziąć udział w głosowaniu należy podać
                                    adres e-mail.
                                </p>

                                {errors.email && (
                                    <p className="text-red-500 uppercase font-semibold text-[12px] tracking-wide">
                                        {errors.email}
                                    </p>
                                )}
                                <input
                                    required
                                    type="email"
                                    value={data.email}
                                    className={`contact-input ${errors.email ? "with-error" : ""}`}
                                    name="email"
                                    placeholder="Adres e-mail*"
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>,
                                    ) =>
                                        setData("email", e.currentTarget.value)
                                    }
                                />
                                {wasSuccessful && (
                                    <div className="text-green-600 space-y-2">
                                        <p className="font-bold text-p">
                                            Potwierdź swój udział w głosowaniu
                                        </p>
                                        <p>
                                            Sprawdź maila i postępuj zgodnie z
                                            nadesłaną instrukcją, aby oddać
                                            głos.
                                        </p>
                                        <p>Dziękujemy!</p>
                                    </div>
                                )}
                                <button
                                    type="submit"
                                    className="border-primary border max-w-[275px] mt-10 w-full button-outline"
                                >
                                    Zagłosuj
                                </button>

                                {error && (
                                    <p className="text-red-500 mt-3 uppercase font-semibold text-[12px] tracking-wide">
                                        {error}
                                    </p>
                                )}
                            </form>

                            {selectedProject === 1 && (
                                <img srcSet={WorkArt1} alt="Praca 1" />
                            )}
                            {selectedProject === 2 && (
                                <img srcSet={WorkArt2} alt="Praca 2" />
                            )}
                            {selectedProject === 3 && (
                                <img srcSet={WorkArt3} alt="Praca 3" />
                            )}
                        </div>
                    </div>
                </Modal>
                <ContactForm smallerMargin />
            </FrontLayout>
        </>
    );
}
